/**
 * Links to our google feedback form.
 */
export const FEEDBACK_LINK = "https://forms.gle/4Laakdrgg2F2W6FE9";

/**
 * Links to our about page and wiki.
 */
export const ABOUT_SAFA_LINK =
  "https://nd-safa.notion.site/About-SAFA-371e041314e74e89a437e7ce21471fc4?pvs=4";

/**
 * Links to our changelog.
 */
export const CHANGELOG_LINK =
  "https://www.notion.so/nd-safa/5155dc357f534eb49f8071a03ce3ae32?v=74f671825a1b4d048909843740c003f1";

/**
 * Links to our security documentation.
 */
export const SECURITY_LINK =
  "https://www.notion.so/nd-safa/Data-Security-and-Privacy-440d393ab2b44f8d986fa7fbc37f0bd9";
